"use client";

import { useEffect, useRef } from "react";

import type { House } from "@/types";

export const ImageGallery = ({
  imagens,
  alt,
}: Pick<House, "imagens"> & { alt: string }) => {
  const gallery = imagens?.slice(1, 2);

  if (gallery?.length === 0) return null;

  return (
    <div className="w-1/2 hidden sm:flex flex-col gap-2">
      {gallery.map((href, index) => (
        <div className="h-full relative" key={`image-${index}`}>
          <ImageWithFallback
            src={href}
            alt={`${alt} - imagem ${index}`}
            className="object-cover w-full h-full"
          />
        </div>
      ))}
    </div>
  );
};

export const ImageWithFallback = ({
  src,
  alt,
  ...props
}: Partial<
  Pick<HTMLImageElement, "src" | "alt" | "className" | "height" | "width">
>) => {
  const imgRef = useRef(null);

  useEffect(() => {
    const img = imgRef.current as unknown as HTMLImageElement;
    if (!img) return;

    const handleError = () => {
      img.src = "/placeholder.svg";
      img.loading = "lazy";
    };

    if (img.complete && img.naturalWidth === 0) {
      handleError();
    } else {
      img.addEventListener("error", handleError);
      return () => img.removeEventListener("error", handleError);
    }
  }, [src]);

  return <img ref={imgRef} src={src} loading="eager" alt={alt} {...props} />;
};
